import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getSewpatGalleryOverlay } from '../../reducers/sewpats';

import RaisedButton from '../buttons/SecondaryRaisedButton';
import { getProductFormData, hasError } from '../../reducers/cart';
import { getMessage } from '../../reducers/i18n';

const ProductForm = ({ productData, cartButtonLabel, hasError }) => {
    const StyledThing = styled.div`
        
        & button {
          margin-bottom: ${props => props.theme.space[3]};
        }
    `;

    const hiddenInputs = () => {
        const inputs = [];
        Object.keys(productData).map(
            (label, index) => {
                inputs.push(<input
                    type='hidden' name={label} value={productData[label]}
                    key={`foxy${index}`}
                />);
            },
        );
        return inputs;
    };

    return (
        <StyledThing >
            <form
                action='https://checkout.stoff.love/cart' method='post'
                acceptCharset='utf-8'
            >
                <input
                    type='hidden' name='h:source' value='schnoffle'
                />
                <RaisedButton
                    type='submit'
                    value='add-to-cart'
                    icon='shopping_cart'
                    text={cartButtonLabel}
                    disabled={hasError}
                />
                <div >
                    {hiddenInputs()}
                </div >
            </form >
        </StyledThing >
    );
};

const mapStateToProps = state => ({
    productData: getProductFormData(state),
    cartButtonLabel: getMessage(state, 'CART_BUTTON_LABEL'),
    hasError: hasError(state),
    figurineOverlay: getSewpatGalleryOverlay(state),
});

export default connect(mapStateToProps)(ProductForm);



// WEBPACK FOOTER //
// ./src/components/addtocart/ProductForm.js